import { render, staticRenderFns } from "./TrainImport.vue?vue&type=template&id=b1ec3018&scoped=true"
import script from "./TrainImport.vue?vue&type=script&lang=js"
export * from "./TrainImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ec3018",
  null
  
)

export default component.exports